import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Store from '../../Store';
import { OnLayerAdd, OnLayerMove, OnLayerRemove, OnLayerRename, OnLayerListVisibilityToggle } from '../_actions/LayerListActions';
import LayerList, { Props } from '../_components/LayerList';

const mapStateToProps = (store:Store, props:Props) => ({
	layersOrder: store.getIn(['create', 'layerList', 'layersOrder']),
	selectedLayerId: store.getIn(['create', 'layerList', 'selectedLayerId']),
	opened: store.getIn(['create', 'layerList', 'opened']),
});

const mapDispatchToProps = (dispatch:Dispatch, props:Props) => ({
	addLayer		: ()							=> dispatch(OnLayerAdd()),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(LayerList);